var features = require('diy/util/features');

require('diy/angular/services/diyimageresize');
require('diy/angular/services/diyanimationframe');
require('diy/angular/services/diyfilename');
require('diy/angular/services/diyfilevalidator');

require('./services/diyfmsectionsdata');
require('./services/diyfmfolders');
require('./services/diyfmuploadqueue');
require('./services/diyfmconfig');
require('./services/diyfmselectiondata');
require('./services/diyfminsertprogress');
require('./services/diyfmmessages');
require('./services/diyfmstatus');
require('./services/diyfmblocking');
require('./services/diyfmtracking');
require('./sources/diyfmsourcestorage');
require('./sources/diyfmsourcekeyvisuals');
require('./sources/diyfmsourcepatterns');
require('./sources/diyfmsourcecms');
require('./sources/diyfmsourcebigstock');
require('./sources/diyfmsource123rf');
require('./models/diyfmsubsectionmodel');
require('./models/diyfmfoldermodel');
require('./models/diyfmunsortedmodel');
require('./models/diyfmallimagesmodel');
require('./models/diyfmitemmodel');
require('./models/diyfmfileitemmodel');
require('./models/diyfmsectionmodel');
require('./sections/diyfmsectionstorage');
require('./sections/diyfmsectioncompany');
require('./sections/diyfmsectionbigstock');
require('./sections/diyfmsection123rf');

require('./controllers/diyfmmain');

require('./directives/diyfmthumbnail');
require('./directives/diyfmtoolbarsearch');
require('./directives/diyfmtoolbarselectall');
require('./directives/diyfmtoolbar');
require('./directives/diyfmbreadcrumb');
require('./directives/diyfmitems');
require('./directives/diyfmsections');
require('./directives/diyfmsection');
require('./directives/diyfmmenu');
require('./directives/diyfmupload');
require('./directives/diyfmprogress');
require('./directives/diyfminsert');
require('./directives/diyfmpreview');
require('./directives/diyfminlineedit');
require('./directives/diyfmdropfiles');
require('./directives/diyfmblockingmask');
require('./directives/diyfmcolorsfilter');
var disclaimerDialog = require('./sources/disclaimerDialog');
var NotificationApi = require('../toolbar/notificationNG/Api').default;

module.exports = function(config) {

    var app, $appEl, tpl, appName = config.appName;

    tpl = '\
        <div class="fm-dialog fm-mode-' + config.mode + '" data-fm-appname="' + appName + '" \
            ng-controller="diyfmmain" style="display: none;"\
            diyfmblockingmask="diyfmblocking"\
            diyfmdropfiles="dropFilesConfig"\
            >\
            \
            <div ng-cloak class="fm-content">\
                <div class="fm-side">\
                    <div diyfmsections="" class="fm-sections"></div>\
                    <div diyfmupload="" class="fm-upload"></div>\
                </div>\
                \
                <div class="fm-main" data-current-subsection="{{currentSubsection.getTypeName()}}">\
                    <div diyfmtoolbar="currentSubsection.getSource().getToolbarItems(currentSubsection)" class="fm-toolbar"></div>\
                    <div diyfmbreadcrumb="" class="fm-breadcrumb"></div>\
                    <div diyfmitems="" class="fm-items"></div>\
                </div>\
            </div>\
            <div ng-cloak class="fm-footer" ng-hide="config.isInManagementMode()">\
                <div data-diyfminsert=""></div>\
            </div>\
            \
            <div ng-cloak class="fm-insert-mask" ng-show="insertprogress.isShown()">\
                <div class="fm-insert-numeric-progress"><span class="ui-icon ui-icon-loading"></span>{{insertprogress.getProgressString()}}</div>\
                <div class="fm-upload-progress" \
                    diyfmprogress="insertprogress.progressConfig">\
                </div>\
            </div>\
        </div>';

    /* create the element, append it to body and create a diy_dialog with it */
    $appEl = jQuery(tpl);
    $appEl.wrap('<div class="diye"></div>').appendTo('body');
    // adapt the initial size of the window to the user's screen
    // 1056 is an optimized default width so that it will fit perfectly 5 thumbnails per row
    // 600 x 400 is the minimal acceptable size of the window, to be usable
    var dialogWidth = Math.min(1056, Math.max(600, jQuery(window).width() - 100));
    var dialogHeight = Math.min(661, Math.max(400, jQuery(window).height() - 100));

    $appEl.diy_dialog({
        title: jimdoData.messages.filemanager.dialog.title,
        width: dialogWidth,
        height: dialogHeight,
        dialogClass: 'fm-dialog-frame',
        closeButton: true,
        closeOnEscape: false,
        helpButton: true,
        helpTopic: 'settings_images_cip',
        resizable: false,
        secondaryHelpTopic: (config.mode == 'selection')?'cip':null,
        secondaryHelpClass: 'feature-guidance-help-button',
        modal: true,
        zIndex: 111112,
        overlayCls: 'filemanager-overlay-cover-all',
        beforeClose: function(ev, ui) {
            var status = getStatus();

            if (status.indexOf('upload') > -1) {
                // for reasons unknown to me, this must be put in a setTimeout, otherwise it will close instantly!
                setTimeout(function() {
                    getInjector().get('diyfmmessages').showMessage({
                        title: jimdoData.messages.filemanager.close.upload.title,
                        content: jimdoData.messages.filemanager.close.upload.message,
                        ok: jimdoData.messages.filemanager.close.upload.wait
                    });
                }, 1);
                return false;
            }

            if (status.indexOf('insert') > -1) {
                // for reasons unknown to me, this must be put in a setTimeout, otherwise it will close instantly!
                setTimeout(function() {
                    getInjector().get('diyfmmessages').showMessage({
                        title: jimdoData.messages.filemanager.close.insert.title,
                        content: jimdoData.messages.filemanager.close.insert.message,
                        ok: jimdoData.messages.filemanager.close.upload.wait
                    });
                }, 1);
                return false;
            }

            return true;
        },
        close: function(ev, ui) {
            destroy();
            jQuery(document).trigger('diy-editor-filemanager-closed');
        }
    });

    jQuery(document).trigger('diy-editor-filemanager-opened');

    // initialize help link
    cms.help.GuidedAssistant._instance._initSiteAdminButtonByClass(cms.help.GuidedAssistant.options.modulesLinkClass);

    /* create angular app and add directives and factories to it */
    app = angular.module(appName, ['ngResource', 'ngSanitize']);

    app.config(["$httpProvider", function($httpProvider) {
        $httpProvider.defaults.headers.common['X-DiyCSRFToken'] = jimdoData.cstok;
        // this header is essential in session expiration handling
        $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

        // error handling
        $httpProvider.interceptors.push(['$q', 'diyfmmessages', function($q, diyfmmessages) {
            return {
                responseError: function(reason) {
                    var urlRequested = reason.config.url;
                    /* we should only catch a rest error */
                    if (urlRequested.indexOf('rest/websites/') > -1) {
                        diyfmmessages.handleGenericError();
                    }

                    return $q.reject('error');
                }
            };
        }]);

        /**
         * this assures that the angular app will route all error $http's through session expiry js check
         */
        $httpProvider.interceptors.push(diy.editor.session.angularHandleExpired);
    }]);

    // this will make available to dinamically register directives
    // even after app bootstrap
    app.config(['$compileProvider', function($compileProvider)
    {
        app.compileProvider = $compileProvider;
    }]);

    app.constant('diyfmconstkeyvisual', 'keyvisuals');
    app.constant('diyfmconstcms', 'cms');
    app.constant('diyfmconstbigstock', 'bigstock');
    app.constant('diyfmconst123rf', '123rf');
    app.constant('diyfmconstbigstockpurchased', 'bigstockpurchased');
    app.constant('diyfmconstpattern', 'patterns');
    app.constant('diyfmconststorage', 'storage');

    diy.angular.loadControllers(app, [
        'diyfmmain'
    ]);

    diy.angular.loadConstants(app, [
        'diywebsiteid'
    ]);

    diy.angular.loadFactories(app, [
        'diyl10n',
        'diyinfo',
        'diyfeatures',
        'diyglobalevents',
        'diyappevents',
        'diyanimationframe',
        'diysqueezebox',
        'diyfiledownload',
        'diyfilevalidator',
        'diyfmsectionsdata',
        'diyfmfolders',
        'diyfmsubsectionmodel',
        'diyfmfoldermodel',
        'diyfmitemmodel',
        'diyfmfileitemmodel',
        'diyfmsectionmodel',
        'diyfmsectionstorage',
        'diyfmsectioncompany',
        'diyfmsectionbigstock',
        'diyfmsection123rf',
        'diyfmuploadqueue',
        'diyimageresize',
        'diyfmallimagesmodel',
        'diyfmunsortedmodel',
        'diyfmconfig',
        'diyfmselectiondata',
        'diyfilename',
        'diyfminsertprogress',
        'diyfmmessages',
        'diyfmstatus',
        'diyfmblocking',
        'diyfmtracking',
        'diyfmsourcestorage',
        'diyfmsourcekeyvisuals',
        'diyfmsourcepatterns',
        'diyfmsourcecms',
        'diyfmsourcebigstock',
        'diyfmsource123rf',
    ]);

    diy.angular.loadFilters(app, [

    ]);

    diy.angular.loadDirectives(app, [
        'diybutton',
        'diysearchbox',
        'diycombobox',
        'diyfmthumbnail',
        'diyfmtoolbarsearch',
        'diyfmtoolbarselectall',
        'diyfmtoolbar',
        'diyfmbreadcrumb',
        'diyfmitems',
        'diyfmsections',
        'diyfmsection',
        'diyfmmenu',
        'diyfmupload',
        'diyfmprogress',
        'diyfminsert',
        'diyfmpreview',
        'diyfminlineedit',
        'diyfmdropfiles',
        'diyfmblockingmask',
        'diyfmcolorsfilter'
    ]);

    /* send configuration options */
    app.run(['diyfmconfig', function(diyfmconfig) {
        diyfmconfig.setConfig(config);
    }]);

    var showDisclaimer = function () {
        jQuery(document).trigger(
            "diy-editor-generic-linkInteraction",
            {
                pageName: "cipDisclaimer",
                actionName: "openCipDisclaimer"
            }
        );
        var agreeAction = function() {
            jQuery(document).trigger(
                "diy-editor-generic-linkInteraction",
                {
                    pageName: "cipDisclaimer",
                    actionName: "agreeCipDisclaimer"
                }
            );
            features.enableFeature('cipDisclaimer').then(function(){
                disclaimerDialog.closeDialog();
                bootstrap();
                diy.editor.featureGuidance.show('cip', true);
            });
        };
        var cancelAction = function() {
            jQuery(document).trigger(
                "diy-editor-generic-linkInteraction",
                {
                    pageName: "cipDisclaimer",
                    actionName: "cancelCipDisclaimer"
                }
            );
            destroyDialog();
            disclaimerDialog.closeDialog();
            if (features("notificationsNG")) {
                NotificationApi.schedule(function(){
                    NotificationApi.resume();
                });
            }
        };

        if (features("notificationsNG")) {
            NotificationApi.schedule(function(){
                NotificationApi.pause().then(function(){
                    disclaimerDialog.showDialog(agreeAction, cancelAction);
                });
            });
        } else {
            disclaimerDialog.showDialog(agreeAction, cancelAction);
        }
    };

    var bootstrap = function() {
        /* bootstrap app */
        angular.bootstrap($appEl[0], [appName]);

        jQuery(window).bind('beforeunload.' + appName, function(ev) {
            return jimdoData.messages.filemanager.navigateaway[getStatus()[0]];
        });
    };

    // if we need a migration
    if (jimdoData.features.images_to_storage_migration_needed) {
        // call the migrate action
        $appEl.loadingBox({useOverlay: true, loadingText: jimdoData.messages.filemanager.migrateFirstTime}).show();
        jQuery.ajax({
            url: '/app/cms/migration/migrate-existing-images-to-storage/',
            method: 'GET',
            complete: function() {
                // if completed, no matter the result, open bootstrap the app
                bootstrap();
                // and set the js flag to 0, so it won't migrate again when opened in the same session
                // (on the server-side, flag removal is handled by the migrate action)
                jimdoData.features.images_to_storage_migration_needed = 0;
                $appEl.loadingBox().remove();
            }
        })
    } else if (!features.getPayload('cipDisclaimer')['acknowleged_at'] && jimdoData.market !== 'pl_PL') {
        showDisclaimer();
    } else {
        // if no migration needed, just bootstrap directly
        bootstrap();
    }

    /* convenience method to get the scope */
    var getScope = function() {
        return angular.element($appEl[0]).scope();
    };

    var reload = function() {
        var oldConfig = angular.copy(angular.injector([appName]).invoke(function(diyfmconfig) { return diyfmconfig.getConfig(); }));
        /* destroy current app and bootstrap a new one */
        destroy();
        diy.editor.filemanager = new diy.editor.Filemanager(oldConfig);
    };

    var destroy = function() {
        angular.element($appEl).scope().$broadcast('$destroy');
        destroyDialog();
    };

    var destroyDialog = function() {
        $appEl.diy_dialog('destroy');
        $appEl.empty();
        $appEl.remove();
        jQuery(window).unbind('.' + appName);
    };

    var getInjector = function() {
        var injector = angular.element($appEl[0]).injector();
        return injector;
    };

    var getStatus = function() {
        var injector = getInjector();
        var status = injector.get('diyfmstatus').getCurrentStatus();
        return status;
    };

    var close = function() {
        $appEl.diy_dialog('close');
    };

    var getConstant = function(constantName) {
        var returnFn = new Function(constantName, 'return ' + constantName + ';');
        return angular.injector([appName]).invoke(returnFn);
    };

    jQuery(document).trigger('diy-editor-generic-sectionAccessed', {
        'sectionCodeName': 'fileManager',
        'propName': config.mode
    });

    /* expose public methods */
    return angular.extend(this, {
        getScope: getScope,
        close: close,
        reload: reload,
        getStatus: getStatus,
        getInjector: getInjector,
        getConstant: getConstant
    });
};



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/Filemanager.js
 ** module id = 931
 ** module chunks = 0
 **/